import { useMutation } from '@tanstack/react-query';
import postUser from '../queries/postUser';

export default function usePostUser(onSuccess: () => void) {
  return useMutation((value: any) => postUser(value, () => onSuccess()))
}
